import axios from "axios";

const deleteTour = async (token, tourId) => {
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/tours/${tourId}`;
  try {
    const response = await axios.delete(path, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  }
};

export default deleteTour;
